import React from "react";
import { Backdrop, CircularProgress, Stack, Theme, Typography } from "@mui/material"
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

interface PropsViewLoadingBackDrop {
    showLoading: boolean
    backdropInvisible: boolean
    msg?: string
}

export default function ViewLoadingBackDrop(props: PropsViewLoadingBackDrop) {
    const { backdropInvisible, showLoading, msg } = props;
    const { classes } = useStyles();
    return (
        <Backdrop className={classes.backdrop} open={showLoading} invisible={backdropInvisible} >
            <Stack direction={"column"} spacing={2} alignItems={"center"}>
                <CircularProgress color="inherit" />
                {msg && (
                    <Typography variant="caption">{msg}</Typography>
                )}
            </Stack>
        </Backdrop>
    )
}